import { ILayer } from './types';
import * as L from 'leaflet';

export const DEFAULT_MAP_BOUNDS = L.latLngBounds(
  {
    lat: 54.63849772247449,
    lng: 21.077526310601854,
  },
  {
    lat: 56.03179105776196,
    lng: 26.381176212945604,
  },
);

export const FIELDS_LAYER_ID = 'layer_1';

const defaultWmsTileOptions = {
  layerType: 'wmsTile' as 'wmsTile',
  visible: false,
  opacity: 1,
};

export const MAP_LAYERS: {
  BASE_LAYERS: {
    MAP: {
      url: string;
    };
    SATELLITE: {
      url: string;
    };
  };
  LAYERS: ILayer[];
} = {
  BASE_LAYERS: {
    MAP: {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    },
    SATELLITE: {
      url: 'https://www.maps.lt/arcgis/rest/services/mapslt_ortofoto/MapServer',
    },
  },
  LAYERS: [
    {
      id: FIELDS_LAYER_ID,
      name: 'Laukai',
      visible: true,
      layerType: 'polygon',
      opacity: 1,
    },
    {
      ...defaultWmsTileOptions,
      id: 'layer_2',
      name: 'Administraciniai laukai',
      layers: 'importuoti_sluoksinai:Administraciniai_laukai',
    },
    // {
    //   ...defaultWmsTileOptions,
    //   id: 'layer_3',
    //   name: 'Dirvožemių konturas',
    //   layers: 'importuoti_sluoksinai:konturas',
    // },
    {
      ...defaultWmsTileOptions,
      id: 'layer_4',
      name: 'Paviršinio vandens telkinių apsaugos zonos',
      layers:
        'importuoti_sluoksinai:Paviršinio vandens telkinių apsaugos zonos',
    },
    {
      ...defaultWmsTileOptions,
      id: 'layer_5',
      name: 'Vandenviečių apsaugos zonos',
      layers: 'importuoti_sluoksinai:VANDENV_AZ',
    },
    {
      ...defaultWmsTileOptions,
      id: 'layer_6',
      name: 'Natura 2000',
      layers: 'importuoti_sluoksinai:Buveinių apsaugai svarbios teritorijos',
    },
    {
      ...defaultWmsTileOptions,
      id: 'layer_7',
      name: 'Draustiniai',
      layers: 'importuoti_sluoksinai:Draustiniai',
    },
    // {
    //   ...defaultWmsTileOptions,
    //   id: 'layer_8',
    //   name: 'Alytaus apskritis',
    //   layers: 'importuoti_sluoksinai:vertinimas_Alytaus_apskritis',
    // },
    // {
    //   ...defaultWmsTileOptions,
    //   id: 'layer_91',
    //   name: 'Kauno apskritis',
    //   layers: 'importuoti_sluoksinai:vertinimas_Kauno_apskritis',
    // },

    // {
    //   ...defaultWmsTileOptions,
    //   id: 'layer_9',
    //   name: 'Marijampoles apskritis',
    //   layers: 'importuoti_sluoksinai:vertinimas_Marijampoles_apskritis',
    // },
    // {
    //   ...defaultWmsTileOptions,
    //   id: 'layer_10',
    //   name: 'Panevezio apskritis',
    //   layers: 'importuoti_sluoksinai:vertinimas_Panevezio_apskritis',
    // },

    // {
    //   ...defaultWmsTileOptions,
    //   id: 'layer_11',
    //   name: 'Siauliu apskritis',
    //   layers: 'importuoti_sluoksinai:vertinimas_Siauliu_apskritis',
    // },
    // {
    //   ...defaultWmsTileOptions,
    //   id: 'layer_12',
    //   name: 'Taurages apskritis',
    //   layers: 'importuoti_sluoksinai:vertinimas_Taurages_apskritis',
    // },
    // {
    //   ...defaultWmsTileOptions,
    //   id: 'layer_13',
    //   name: 'Telsiu apskritis',
    //   layers: 'importuoti_sluoksinai:vertinimas_Telsiu_apskritis',
    // },
    // {
    //   ...defaultWmsTileOptions,
    //   id: 'layer_14',
    //   name: 'Utenos apskritis',
    //   layers: 'importuoti_sluoksinai:vertinimas_Utenos_apskritis',
    // },
    // {
    //   ...defaultWmsTileOptions,
    //   id: 'layer_15',
    //   name: 'Vilniaus apskritis',
    //   layers: 'importuoti_sluoksinai:vertinimas_Vilniaus_apskritis',
    // },
    // {
    //   ...defaultWmsTileOptions,
    //   id: 'layer_16',
    //   name: 'vietove kv',
    //   layers: 'importuoti_sluoksinai:vietove_kv',
    // },
    // {
    //   ...defaultWmsTileOptions,
    //   id: 'layer_17',
    //   name: 'vietove lr',
    //   layers: 'importuoti_sluoksinai:vietove_lr',
    // },
    // {
    //   ...defaultWmsTileOptions,
    //   id: 'layer_18',
    //   name: 'vietove sav',
    //   layers: 'importuoti_sluoksinai:vietove_sav',
    // },
    // {
    //   ...defaultWmsTileOptions,
    //   id: 'layer_19',
    //   name: 'vietove sen',
    //   layers: 'importuoti_sluoksinai:vietove_sen',
    // },
  ],
};

export const mapColors = {
  colors: {
    YELLOW: '#eabc38',
    BLUE: '#1995b8',
    GREEN: '#219653',
    DEFAULT: '#a5a5a5',
  },

  percentage: '#fff',
  markerCluster: '#134e2b',
  markerDefault: '#219653',
  markerSelectedBorderColor: '#ef4343',
  markerBackground: 'rgba(255,255,255,0.7)',
  polygon: {
    default: {
      fillColor: '#FAAD14',
      color: '#3f3f3f',
    },
    selected: {
      fillColor: '#52C41A',
      color: '#ef4343',
    },
  },
};
